import { Id } from "./basic";
import { PublicKeyField } from "../serialization/PublicKeyField";
export class TokenAccountId extends Id {
    constructor(key) {
        super(key);
    }
    static native(walletId) {
        return TokenAccountId.of(walletId);
    }
    static of(pubKey) {
        return new TokenAccountId(pubKey);
    }
    static field(property) {
        return new SplAccountIdField(property);
    }
}
class SplAccountIdField extends PublicKeyField {
    constructor(property) {
        super(property);
    }
    fromPublicKey(pubKey) {
        return TokenAccountId.of(pubKey);
    }
}
//# sourceMappingURL=TokenAccountId.js.map